import(/* webpackMode: "eager" */ "/home/interim/frontend/app/projects/page.tsx");
